import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_EN.json';
import exercises from './YOGA_EXERCISES_EN.json';
import recipes from './YOGA_RECIPES_EN.json';

export const YOGA_DATA_EN: ServiceData = {
  articles,
  exercises,
  recipes,
};
